<template>
	<div ref="resultsWrapper">
		<div 
			ref="resultsWrapperInner" 
			aria-live="polite" 
			:class="['dc-post-grid-results-inner', results[0].post_type]"
		>
			<p v-if="results.length===0">{{ dctxt('No posts found...') }}</p>
			<div 
				v-for="(result, index) in results" 
				:key="'result-' + index" 
				class="item"
			>
				<PersonCard 
					v-if="results[0].post_type == 'dc_person'"
					:id="result.id" 
					:title="result.title" 
					:excerpt="result.excerpt" 
					:url="result.url" 
					:image="result.image" 
					:label="result.label" 
					:position="result.position" 
					:phone="result.phone" 
					:email="result.email" 
					:bio="result.bio" 
				/>
				<CourseCard 
					v-else-if="['dc_course', 'page'].includes(results[0].post_type)"
					:id="result.id" 
					:title="result.title" 
					:excerpt="result.excerpt" 
					:url="result.url" 
					:image="result.image" 
					:label="result.label" 
				/>
				<NansenCard 
					v-else
					:id="result.id" 
					:title="result.title" 
					:excerpt="result.excerpt" 
					:url="result.url" 
					:image="result.image" 
					:label="result.label" 
					:terms="result.terms" 
				/>
			</div>
		</div>
		<LoadMore 
			v-if="showLoadMore && !endOfResults && typeof totalPages === 'undefined'"
			:loading="loading" 
			:searchButtonId="searchButtonId"
			@click.stop.prevent="loadMore" />
	</div>
</template>

<script>
import {Translatable} from '@dc-post-grid/mixins/Translatable';
import NansenCard from './cards/NansenCard.vue';
import PersonCard from './cards/PersonCard.vue';
import CourseCard from './cards/CourseCard.vue';
import LoadMore from '@dc-post-grid/layout/ui/LoadMore';
export default {
	mixins: [
		Translatable,
	],
	props: {
		loading: {
			type: Boolean,
			required: true
		},
		results: {
			type: Array,
			required: true
		},
		showLoadMore: {
			type: Boolean,
			default: false,
			required: true
		},
		totalPages: {
			type: Number,
			required: false
		},
		endOfResults: {
			type: Boolean,
			default: false,
			required: true
		},
		searchButtonId: {
			type: String,
			required: true
		}
	},
	components: {
		NansenCard,
		PersonCard,
		CourseCard,
		LoadMore,
	}
}
</script>
